export default __webpack_public_path__ + "static/media/2009.293b8845.png";